import "media-chrome/dist/lang/de.js";
import "media-chrome/dist/lang/es.js";
import "media-chrome/dist/lang/fr.js";
import "media-chrome/dist/lang/pt.js";
import "media-chrome/dist/lang/zh-CN.js";
import "media-chrome/dist/lang/zh-TW.js";
import type { TranslateDictionary } from "media-chrome/dist/lang/en.js";
import { MediaChromeMenu } from "media-chrome/dist/menu/media-chrome-menu.js";
import { addTranslation, getResolvedLanguage, setLanguage } from "media-chrome/dist/utils/i18n.js";

import { uiLanguageOf } from "@/lib/site/site-routing";

const Ja: TranslateDictionary = {
  "Start airplay": "AirPlay を開始",
  "Stop airplay": "AirPlay を停止",
  Audio: "音声",
  Captions: "字幕",
  "Enable captions": "字幕をオン",
  "Disable captions": "字幕をオフ",
  "Start casting": "キャストを開始",
  "Stop casting": "キャストを停止",
  "Enter fullscreen mode": "全画面表示",
  "Exit fullscreen mode": "全画面表示を終了",
  Mute: "ミュート",
  Unmute: "ミュート解除",
  Loop: "ループ",
  "Enter picture in picture mode": "ピクチャー・イン・ピクチャー",
  "Exit picture in picture mode": "ピクチャー・イン・ピクチャーを終了",
  Play: "再生",
  Pause: "一時停止",
  "Playback rate": "再生速度",
  "Playback rate {playbackRate}": "再生速度 {playbackRate}",
  Quality: "画質",
  "Seek backward": "戻る",
  "Seek forward": "進む",
  Settings: "設定",
  Auto: "自動",
  "audio player": "オーディオプレーヤー",
  "video player": "動画プレーヤー",
  volume: "音量",
  seek: "シーク",
  "closed captions": "字幕",
  "current playback rate": "現在の再生速度",
  "playback time": "再生時間",
  "media loading": "読み込み中",
  settings: "設定",
  "audio tracks": "音声トラック",
  quality: "画質",
  play: "再生",
  pause: "一時停止",
  mute: "ミュート",
  unmute: "ミュート解除",
  "chapter: {chapterName}": "チャプター: {chapterName}",
  live: "ライブ",
  Off: "オフ",
  "start airplay": "AirPlay を開始",
  "stop airplay": "AirPlay を停止",
  "start casting": "キャストを開始",
  "stop casting": "キャストを停止",
  "enter fullscreen mode": "全画面表示",
  "exit fullscreen mode": "全画面表示を終了",
  "enter picture in picture mode": "ピクチャー・イン・ピクチャー",
  "exit picture in picture mode": "ピクチャー・イン・ピクチャーを終了",
  "seek to live": "ライブに移動",
  "playing live": "ライブ再生中",
  "seek back {seekOffset} seconds": "{seekOffset} 秒戻る",
  "seek forward {seekOffset} seconds": "{seekOffset} 秒進む",
  "Network Error": "ネットワークエラー",
  "Decode Error": "デコードエラー",
  "Source Not Supported": "対応していない形式です",
  "Encryption Error": "暗号化エラー",
  "A network error caused the media download to fail.":
    "ネットワークエラーのため、メディアを読み込めませんでした。",
  "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.":
    "メディアのエラーで再生が中断されました。ファイルが壊れているか、ブラウザーがこの形式に対応していない可能性があります。",
  "An unsupported error occurred. The server or network failed, or your browser does not support this format.":
    "再生できませんでした。サーバーやネットワークの問題か、ブラウザーがこの形式に対応していない可能性があります。",
  "The media is encrypted and there are no keys to decrypt it.":
    "メディアは暗号化されており、復号する鍵がありません。",
  hour: "時間",
  hours: "時間",
  minute: "分",
  minutes: "分",
  second: "秒",
  seconds: "秒",
  "{time} remaining": "残り {time}",
  "{currentTime} of {totalTime}": "{currentTime} / {totalTime}",
  "video not loaded, unknown time.": "動画が読み込まれていないため、時間は不明です。",
};

const Ko: TranslateDictionary = {
  "Start airplay": "AirPlay 시작",
  "Stop airplay": "AirPlay 중지",
  Audio: "오디오",
  Captions: "자막",
  "Enable captions": "자막 켜기",
  "Disable captions": "자막 끄기",
  "Start casting": "전송 시작",
  "Stop casting": "전송 중지",
  "Enter fullscreen mode": "전체 화면",
  "Exit fullscreen mode": "전체 화면 종료",
  Mute: "음소거",
  Unmute: "음소거 해제",
  Loop: "반복",
  "Enter picture in picture mode": "PIP 모드",
  "Exit picture in picture mode": "PIP 모드 종료",
  Play: "재생",
  Pause: "일시정지",
  "Playback rate": "재생 속도",
  "Playback rate {playbackRate}": "재생 속도 {playbackRate}",
  Quality: "화질",
  "Seek backward": "뒤로",
  "Seek forward": "앞으로",
  Settings: "설정",
  Auto: "자동",
  "audio player": "오디오 플레이어",
  "video player": "동영상 플레이어",
  volume: "볼륨",
  seek: "탐색",
  "closed captions": "자막",
  "current playback rate": "현재 재생 속도",
  "playback time": "재생 시간",
  "media loading": "불러오는 중",
  settings: "설정",
  "audio tracks": "오디오 트랙",
  quality: "화질",
  play: "재생",
  pause: "일시정지",
  mute: "음소거",
  unmute: "음소거 해제",
  "chapter: {chapterName}": "챕터: {chapterName}",
  live: "라이브",
  Off: "끄기",
  "start airplay": "AirPlay 시작",
  "stop airplay": "AirPlay 중지",
  "start casting": "전송 시작",
  "stop casting": "전송 중지",
  "enter fullscreen mode": "전체 화면",
  "exit fullscreen mode": "전체 화면 종료",
  "enter picture in picture mode": "PIP 모드",
  "exit picture in picture mode": "PIP 모드 종료",
  "seek to live": "라이브로 이동",
  "playing live": "라이브 재생 중",
  "seek back {seekOffset} seconds": "{seekOffset}초 뒤로",
  "seek forward {seekOffset} seconds": "{seekOffset}초 앞으로",
  "Network Error": "네트워크 오류",
  "Decode Error": "디코딩 오류",
  "Source Not Supported": "지원하지 않는 형식",
  "Encryption Error": "암호화 오류",
  "A network error caused the media download to fail.":
    "네트워크 오류로 미디어를 불러오지 못했습니다.",
  "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.":
    "미디어 오류로 재생이 중단되었습니다. 파일이 손상되었거나 브라우저가 이 형식을 지원하지 않을 수 있습니다.",
  "An unsupported error occurred. The server or network failed, or your browser does not support this format.":
    "재생할 수 없습니다. 서버나 네트워크 문제이거나 브라우저가 이 형식을 지원하지 않을 수 있습니다.",
  "The media is encrypted and there are no keys to decrypt it.":
    "미디어가 암호화되어 있으며 해독할 키가 없습니다.",
  hour: "시간",
  hours: "시간",
  minute: "분",
  minutes: "분",
  second: "초",
  seconds: "초",
  "{time} remaining": "{time} 남음",
  "{currentTime} of {totalTime}": "{currentTime} / {totalTime}",
  "video not loaded, unknown time.": "동영상이 로드되지 않아 시간을 알 수 없습니다.",
};

const Ru: TranslateDictionary = {
  "Start airplay": "Начать AirPlay",
  "Stop airplay": "Остановить AirPlay",
  Audio: "Аудио",
  Captions: "Субтитры",
  "Enable captions": "Включить субтитры",
  "Disable captions": "Выключить субтитры",
  "Start casting": "Начать трансляцию",
  "Stop casting": "Остановить трансляцию",
  "Enter fullscreen mode": "Во весь экран",
  "Exit fullscreen mode": "Выйти из полноэкранного режима",
  Mute: "Выключить звук",
  Unmute: "Включить звук",
  Loop: "Повтор",
  "Enter picture in picture mode": "Картинка в картинке",
  "Exit picture in picture mode": "Выйти из режима «картинка в картинке»",
  Play: "Воспроизвести",
  Pause: "Пауза",
  "Playback rate": "Скорость воспроизведения",
  "Playback rate {playbackRate}": "Скорость воспроизведения {playbackRate}",
  Quality: "Качество",
  "Seek backward": "Назад",
  "Seek forward": "Вперёд",
  Settings: "Настройки",
  Auto: "Авто",
  "audio player": "аудиоплеер",
  "video player": "видеоплеер",
  volume: "громкость",
  seek: "перемотка",
  "closed captions": "субтитры",
  "current playback rate": "текущая скорость воспроизведения",
  "playback time": "время воспроизведения",
  "media loading": "загрузка",
  settings: "настройки",
  "audio tracks": "аудиодорожки",
  quality: "качество",
  play: "воспроизвести",
  pause: "пауза",
  mute: "выключить звук",
  unmute: "включить звук",
  "chapter: {chapterName}": "глава: {chapterName}",
  live: "прямой эфир",
  Off: "Выкл.",
  "start airplay": "начать AirPlay",
  "stop airplay": "остановить AirPlay",
  "start casting": "начать трансляцию",
  "stop casting": "остановить трансляцию",
  "enter fullscreen mode": "во весь экран",
  "exit fullscreen mode": "выйти из полноэкранного режима",
  "enter picture in picture mode": "картинка в картинке",
  "exit picture in picture mode": "выйти из режима «картинка в картинке»",
  "seek to live": "перейти к прямому эфиру",
  "playing live": "идёт прямой эфир",
  "seek back {seekOffset} seconds": "назад на {seekOffset} с",
  "seek forward {seekOffset} seconds": "вперёд на {seekOffset} с",
  "Network Error": "Ошибка сети",
  "Decode Error": "Ошибка декодирования",
  "Source Not Supported": "Формат не поддерживается",
  "Encryption Error": "Ошибка шифрования",
  "A network error caused the media download to fail.":
    "Не удалось загрузить медиафайл из-за ошибки сети.",
  "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.":
    "Воспроизведение прервано из-за ошибки. Файл может быть повреждён, или браузер не поддерживает этот формат.",
  "An unsupported error occurred. The server or network failed, or your browser does not support this format.":
    "Не удалось воспроизвести. Возможна ошибка сервера или сети, или браузер не поддерживает этот формат.",
  "The media is encrypted and there are no keys to decrypt it.":
    "Медиафайл зашифрован, а ключей для расшифровки нет.",
  hour: "ч",
  hours: "ч",
  minute: "мин",
  minutes: "мин",
  second: "с",
  seconds: "с",
  "{time} remaining": "осталось {time}",
  "{currentTime} of {totalTime}": "{currentTime} из {totalTime}",
  "video not loaded, unknown time.": "видео не загружено, время неизвестно.",
};

addTranslation("ja", Ja);
addTranslation("ko", Ko);
addTranslation("ru", Ru);

const BACK_TO_PREVIOUS_MENU: Record<string, string> = {
  "zh-CN": "返回上一级菜单",
  "zh-TW": "返回上一層選單",
  ja: "前のメニューに戻る",
  ko: "이전 메뉴로 돌아가기",
  de: "Zurück zum vorherigen Menü",
  fr: "Retour au menu précédent",
  es: "Volver al menú anterior",
  pt: "Voltar ao menu anterior",
  ru: "Назад к предыдущему меню",
};

const menuTemplate = MediaChromeMenu.getTemplateHTML;
MediaChromeMenu.getTemplateHTML = (attrs) => {
  const label = BACK_TO_PREVIOUS_MENU[getResolvedLanguage()];
  const html = menuTemplate(attrs);

  return label ? html.replace('aria-label="Back to previous menu"', `aria-label="${label}"`) : html;
};

export function mediaChromeLanguageOf(locale: string): string {
  return locale === "zh" ? "zh-CN" : locale === "zh-tw" ? "zh-TW" : locale;
}

if (typeof document !== "undefined") {
  setLanguage(mediaChromeLanguageOf(uiLanguageOf(document.documentElement.lang)));
}
